import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sampleReceived } from "redux-store/kit/kit.slice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import { getnotReceiveTests, getnotsubmittedTests } from "redux-store/lab-tests/tests.slice";

type PropsType = {
  kit?: any;
  setLoadings?: any;
  setTests: any;
};

const UserDetailsMobile = ({ kit, setTests, setLoadings }: PropsType) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState("");

  const handleSample = () => {
    setLoading(kit);
    dispatch(sampleReceived(kit)).then(() => {
      setLoading("");
      setLoadings(true);
      dispatch(getnotReceiveTests()).then((res) => {
        const data = res.payload.labResults;
        setTests(data);
        setLoadings(false);
      });
    });
  };

  return (
    <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
      <div className="tw-w-[80%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
        {/* 1st main col */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* 1st col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">User Name</span>
            <span className="">{kit.userId ? kit.userId.fullName : "None"}</span>
          </div>
          <hr />
          {/* 2nd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">Pet Name</span>
            <span className="tw-text-start">{kit?.petId?.petName ? kit?.petId?.petName : "None"}</span>
          </div>
          <hr />
          {/* 3rd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">Activation Code</span>
            <span className="">{kit.kitId ? kit.kitId.code : ""}</span>
          </div>
        </div>
        {/* 2nd main col */}
        <div className="tw-w-[80%] tw-mx-auto tw-flex tw-items-center tw-justify-center tw-gap-3">
          <button
            className="tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-[0.625rem] tw-text-md tw-text-[#FFFFFF]"
            onClick={() => {
              navigate("/admin/lab-result");
            }}
          >
            View
          </button>
          <button
            className={`${
              kit?.kitId?.recieved
                ? "tw-min-w-fit tw-text-md tw-text-gray-400 tw-font-bold tw-py-2 tw-px-6  tw-rounded-lg tw-border-gray-400 tw-border-2"
                : "tw-min-w-fit tw-text-md tw-text-[#000] tw-font-bold tw-py-2 tw-px-6  tw-rounded-lg tw-border-black tw-border-2"
            } `}
            onClick={handleSample}
            disabled={kit?.kitId?.recieved || loading === kit}
          >
            {loading === kit ? "updating..." : "Sample Received"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsMobile;
